import React from 'react';
import { SchoolDate } from 'types';

interface SchoolDateLine {
  key: string;
  label: string;
  date: string;
}

function getSchoolDateLines(
  schoolDates?: SchoolDate[] | null
): SchoolDateLine[] {
  if (!schoolDates?.length) {
    return [];
  }

  return schoolDates.flatMap((schoolDate, index) => {
    const date = schoolDate?.dates?.find((value) => Boolean(value));
    if (!schoolDate?.label || !date) {
      return [];
    }

    return [
      {
        key: `${schoolDate.schoolDateType || 'date'}-${index}`,
        label: schoolDate.label,
        date,
      },
    ];
  });
}

interface SchoolDatesProps {
  schoolDates?: SchoolDate[] | null;
  className: string;
}

export default function SchoolDates({
  schoolDates,
  className,
}: SchoolDatesProps): React.JSX.Element | null {
  const lines = getSchoolDateLines(schoolDates);

  if (!lines.length) {
    return null;
  }

  if (lines.length === 1) {
    const [line] = lines;
    return <p className={className}>Classes start on {line.date}</p>;
  }

  return (
    <ul className={className}>
      {lines.map((line) => (
        <li key={line.key}>
          {line.label} {line.date}
        </li>
      ))}
    </ul>
  );
}
